// src/services/depositService.js

import API from './api';

/*
|--------------------------------------------------------------------------
| GET DEPOSITS
|--------------------------------------------------------------------------
*/

export const getDeposits = async (
    page = 1,
    search = '',
    perPage = 10
) => {

    try {

        const formData = new FormData();

        formData.append('page', page);

        formData.append('per_page', perPage);

        if (search) {
            formData.append('search', search);
        }

        const response = await API.post(
            `/admin/client/deposit`,
            formData
        );

        return response.data;

    } catch (error) {

        throw (
            error.response?.data || {
                status: false,
                message: 'Failed to fetch deposits'
            }
        );

    }

};

/*
|--------------------------------------------------------------------------
| EXPORT DEPOSITS
|--------------------------------------------------------------------------
*/

export const exportDeposits = (
    deposits = []
) => {

    try {

        const json = JSON.stringify(
            deposits,
            null,
            2
        );

        const blob = new Blob(
            [json],
            {
                type: 'application/json'
            }
        );

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');

        a.href = url;

        a.download = `deposits-${Date.now()}.json`;

        document.body.appendChild(a);

        a.click();

        a.remove();

        window.URL.revokeObjectURL(url);

    } catch (error) {

        console.error(
            'Export deposits error:',
            error
        );

    }

};